export const SCOPED_ADMIN_FLAG_PERMISSIONS = {
  canChangeGeneralSettings: {
    label: 'Allow user to change organizational settings in the Admin Center',
    permissions: ['generalSettings:ManageSettings'],
    defaultValue: false
  },
  canAddRemoveUsers: {
    label: 'Allow user to add or remove users within their assigned scope',
    permissions: ['user:Create', 'user:Delete'],
    defaultValue: true
  },
  canStartEditCycles: {
    label: 'Allow user to start reviews, surveys, and 360° feedback within their assigned scope',
    permissions: ['reviewCycle:Start', 'reviewCycle:Update'],
    defaultValue: true
  },
  canEditUserAttributes: {
    label: 'Allow user to edit user attributes within their assigned scope',
    permissions: ['userAttribute:Update'],
    defaultValue: true
  },
  canEditUserManager: {
    label: 'Users can edit managers for users within their scope',
    permissions: ['manager:Update'],
    defaultValue: false
  }
}

export const SCOPED_ADMIN_FLAG_KEYS = Object.keys(SCOPED_ADMIN_FLAG_PERMISSIONS)

export const resolveFlagFromPermissions = (permissions, flagKey) => {
  const required = SCOPED_ADMIN_FLAG_PERMISSIONS[flagKey]?.permissions ?? []
  const flat = (permissions ?? []).map(p => (typeof p === 'string' ? p : p.permission))
  return flat.includes('*:*') || required.some(perm => flat.includes(perm))
}
